// import green from '@material-ui/core/colors/green';

export default {
  palette: {
    // primary: green
  }
}
